export const minimumPostTitleLength = 25;
export const maximumPostTitleLength = 150;
export const minimumPostDetailsLength = 100;
